import { ClientOrganizationCreateRequestTagsEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { TFunction } from 'i18next';

import {
  createDefaults,
  editDefaults
} from '@/features/profile-setting/components/organization-extensions/territorial-authority/defaults';
import {
  toCreatePayload,
  toEditPayload
} from '@/features/profile-setting/components/organization-extensions/territorial-authority/payload';
import { territorialAuthorityDataSchema } from '@/features/profile-setting/components/organization-extensions/territorial-authority/schema';
import type { OrganizationExtension } from '@/features/profile-setting/components/organization-extensions/types';

export const territorialAuthorityExtension: OrganizationExtension<'territorialAuthority'> =
  {
    dataKey: 'territorialAuthority',
    tag: ClientOrganizationCreateRequestTagsEnum.TerritorialAuthority,
    schemaFragment: (
      t: TFunction<
        'profile-setting',
        'screens.organization-create' | 'screens.organization-edit'
      >
    ) => territorialAuthorityDataSchema(t),
    createDefaults,
    editDefaults,
    toCreatePayload,
    toEditPayload
  };
